<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*, *::before, *::after { box-sizing: border-box; }
html, body { margin: 0; padding: 0; }
</style>
